import gql from 'graphql-tag';
export default gql`
  mutation UpdateQuestionById($input: UpdateQuestionByIdInput!) {
    updateQuestionById(input: $input) {
      clientMutationId
    }
  }
`;
